module.exports = {"version":"0.1.0"}


//////////////////
// WEBPACK FOOTER
// ./~/tartan-fingerprint/src/@package.js
// module id = 72
// module chunks = 0